import {
  GF_Checkbox,
  GF_Field,
  GF_FieldError,
  GF_Radio,
  GF_Select,
} from '../../model/gforms/gform';
import CheckboxField from './fields/CheckboxField';
import EmailField from './fields/EmailField';
import PhoneField from './fields/PhoneField';
import RadioField from './fields/RadioField';
import SectionField from './fields/SectionField';
import SelectField from './fields/SelectField';
import SurveyField from './fields/SurveyField';
import TextAreaField from './fields/TextAreaField';
import TextField from './fields/TextField';
import UniqueField from './fields/UniqueField';

interface Props {
  field: GF_Field;
  fieldErrors: GF_FieldError[];
}

export default function GravityFormsField({ field, fieldErrors }: Props) {
  switch (field.type) {
    case 'checkbox':
      return <CheckboxField field={field} fieldErrors={fieldErrors} />;
    case 'email':
      return <EmailField field={field} fieldErrors={fieldErrors} />;
    case 'phone':
      return <PhoneField field={field} fieldErrors={fieldErrors} />;
    case 'radio':
      return <RadioField field={field} fieldErrors={fieldErrors} />;
    case 'select':
      return <SelectField field={field} fieldErrors={fieldErrors} />;
    case 'text':
      return <TextField field={field} fieldErrors={fieldErrors} />;
    case 'textarea':
      return <TextAreaField field={field} fieldErrors={fieldErrors} />;
    case 'poll':
      const { poll_field_type } = field;
      switch (poll_field_type) {
        case 'radio':
          const radioField: GF_Radio = {
            ...field,
            type: 'radio',
            choices: field.choices,
            cssClass: field.cssClass,
          };
          return <RadioField field={radioField} fieldErrors={fieldErrors} />;
        case 'checkbox':
          const checkboxField: GF_Checkbox = {
            ...field,
            type: 'checkbox',
            choices: field.choices,
            cssClass: field.cssClass,
          };
          return (
            <CheckboxField field={checkboxField} fieldErrors={fieldErrors} />
          );
        case 'select':
          const selectField: GF_Select = {
            ...field,
            type: 'select',
            choices: field.choices,
            cssClass: field.cssClass,
          };
          return <SelectField field={selectField} fieldErrors={fieldErrors} />;
        default:
          return <p>{`Field type not supported: ${field.type}.`}</p>;
      }
    case 'survey':
      return <SurveyField field={field} fieldErrors={fieldErrors} />;
    case 'unique':
      return <UniqueField field={field} fieldErrors={fieldErrors} />;
    case 'section':
      return <SectionField field={field} fieldErrors={fieldErrors} />;
  }
}
